/**
 * 事件定义
 */
export type EventDefinition = Record<string, () => void>;

/**
 * 事件模型
 */
export default class EventEmitter<EvtDef = EventDefinition> {
  /** 处理函数集合 */
  private _handlersMap: { [key in keyof EvtDef]?: EvtDef[key][] } = {};

  constructor(eventTypes: (keyof EvtDef)[]) {
    this._handlersMap = {};

    eventTypes.forEach(type => {
      this._handlersMap[type] = [];
    });
  }

  /**
   * 判断有没有相关事件类型
   */
  hasType(eventType: string): boolean {
    return typeof this._handlersMap[eventType] !== 'undefined';
  }

  /**
   * 注册事件
   */
  on<K extends keyof EvtDef>(event: K, handler: EvtDef[K]) {
    if (!this.hasType(event as string)) {
      return;
    }

    const handlers = this._handlersMap[event].slice();
    handlers.push(handler);

    this._handlersMap[event] = handlers;
  }

  /**
   * 取消事件
   */
  off<K extends keyof EvtDef>(event: K, handler: EvtDef[K]) {
    const handlers = this._handlersMap[event].slice();
    const index = handlers.findIndex(h => h === handler);

    if (index !== -1) {
      handlers.splice(index, 1);
      this._handlersMap[event] = handlers;
    }
  }

  /**
   * 触发事件
   */
  emit<K extends keyof EvtDef>(event: K, ...args: Parameters<EvtDef[K]>) {
    const handlers = this._handlersMap[event].slice();

    handlers.forEach(handler => {
      // @ts-ignore
      handler.call(null, ...args);
    });
  }

  //
}
